module.exports = __webpack_public_path__ + "img/20231101110014520acx.42386e12.png";